import intersection from 'lodash/intersection'

export const arrayHasElementsIn = (arr1: any[], arr2: any[]) => {
  return intersection(arr1, arr2).length > 0
}
